/*
  A component purely to add a time stamp to the formik data layer. It doesn't render
  any visible html (because of display: none;), it only really functions automatically
  add data to formik

  Future consideration:
  If we have to save weird stuff to formik without user input we could potentially
  rename this and use it to set values based on the initial value prop
*/

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import {
  disabledFieldOptionsShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import {
  getFieldPropShape,
  formPropShape,
} from '../data-structure/formik-proptypes';



class VFTimeStamp extends PureComponent {
  constructor(props) {
    super(props);
    this.updateValue = this.updateValue.bind(this);
  }

  componentDidMount() {
    this.ifDisabledSetDefaultValues({});
    this.updateValue();
  }

  componentDidUpdate(prevProps) {
    const {
      field,
    } = this.props;

    const {
      value,
    } = field;

    this.ifDisabledSetDefaultValues({
      prevProps,
    });

    // FN: 27/01/2020
    // Formik has a race condition where initial values can overwrite values set too early
    // ideally this.updateValue() would work on componentDidMount, however we have to set it
    // with brute force. Probably need to find a better solution :shrugs:
    if (value === null) {
      this.updateValue();
    }
  }

  updateValue() {

    const {
      field,
    } = this.props;

    const {
      name,
      value,
    } = field;

    // if there's already a time stamp, we use that. If not we set our own
    const dateToSet = value ? value : moment.tz(DEFAULT_TIMEZONE).format();

    this.props.form.setFieldValue(name, dateToSet);
    this.props.form.setFieldTouched(name, true);

    return null;
  }

  ifDisabledSetDefaultValues(params) {
    const {
      prevProps,
    } = params;
    const {
      name,
      value,
    } = this.props.field;
    const {
      disabled,
      disabledValue,
      unDisabledValue,
    } = this.props.disabledFieldOptions;
    // check if the previous props had set it to disabled
    const prevDisabled = prevProps ? prevProps.disabledFieldOptions.disabled : false;

    if (!disabled) {
      if (prevDisabled) {
        this.props.form.setFieldValue(name, unDisabledValue);
        this.props.form.setFieldTouched(name, true);
      }
      return null;
    }


    if (JSON.stringify(value) !== JSON.stringify(disabledValue)) {
      this.props.form.setFieldValue(name, disabledValue);
      this.props.form.setFieldTouched(name, true);
    }
    return null;
  }

  render() {
    // Whilst this purely a data level component
    return null;
  }
}



VFTimeStamp.propTypes = {
  // we have to define the value within the data structure for field
  field: getFieldPropShape(PropTypes.string),
  form: formPropShape,
  disabledFieldOptions: disabledFieldOptionsShape,
};

// FN: 21/01/20
// probably won't ever have to use this as we only do it for validation really
const noValueVFTimeInput = (value) => {
  if (value === null) {
    return true;
  }

  return !value;
};
// This is a reference to the component. This is needed as the value for each form field is displayed on a change summary
// page but this is dependant on what type of form field is used
const VF_TIME_STAMP = 'v-f-time-stamp';

export {
  VFTimeStamp,
  noValueVFTimeInput,
  VF_TIME_STAMP,
};
